import axios from "axios";
import {
    b2bLeadsCRUDApi,
    b2bLeadNotesCRUDApi,
    b2bLeadUploadApi,
    b2bLeadsCampaignFolderApi,
    b2bLeadsDistrictFolderApi,
    b2bLeadsViewApi,
    leadStatsApi,
    b2bCampaignsViewApi,
    b2bCampaignsCRUDApi,
    b2bClientDataDownloadApi,
    b2bBulkLeadAssignApi,
    b2bSalespersonDashboardApi,
    b2bLogInteractionApi,
    b2bLeadWorkflowDetailApi,
    b2bLeadAssignmentsApi,
    b2bLeadInteractionsApi,
    b2bLeadFollowupsApi,
    b2bSalespersonListApi,
    b2bQuickAddLeadApi,
    b2bMyDealersApi,
    paidB2BDealersApi,
} from "../constants/apis";
import { getUserToken } from "../helpers/local_storage_helpers";

const getHeaders = () => {
    const token = getUserToken();
    return {
        headers: {
            Authorization: `Token ${token}`,
        },
    };
};

export const getB2BCampaigns = async (query = "") => {
    try {
        const response = await axios.get(`${b2bCampaignsViewApi}${query}`, getHeaders());
        return response;
    } catch (error) {
        return error.response;
    }
};

export const createB2BCampaign = async (data) => {
    try {
        const response = await axios.post(b2bCampaignsCRUDApi, data, getHeaders());
        return response;
    } catch (error) {
        return error.response;
    }
};

export const getB2BLeads = async (query = "") => {
    try {
        const response = await axios.get(`${b2bLeadsViewApi}${query}`, getHeaders());
        return response;
    } catch (error) {
        return error.response;
    }
};

export const createB2BLead = async (data) => {
    try {
        const response = await axios.post(b2bLeadsCRUDApi, data, getHeaders());
        return response;
    } catch (error) {
        return error.response;
    }
};

export const updateB2BLead = async (id, data) => {
    try {
        const response = await axios.patch(`${b2bLeadsCRUDApi}${id}/`, data, getHeaders());
        return response;
    } catch (error) {
        return error.response;
    }
};

export const bulkAssignB2BLeads = async (data) => {
    try {
        const response = await axios.post(b2bBulkLeadAssignApi, data, getHeaders());
        return response;
    } catch (error) {
        return error.response;
    }
};

export const getB2BSalespersonDashboard = async (query = "") => {
    try {
        const qs = query ? (String(query).startsWith("?") ? query : `?${query}`) : "";
        const response = await axios.get(`${b2bSalespersonDashboardApi}${qs}`, getHeaders());
        return response;
    } catch (error) {
        return error.response;
    }
};

export const logB2BInteraction = async (data) => {
    try {
        const response = await axios.post(b2bLogInteractionApi, data, getHeaders());
        return response;
    } catch (error) {
        return error.response;
    }
};

export const getB2BLeadWorkflowDetail = async (leadId) => {
    try {
        const response = await axios.get(`${b2bLeadWorkflowDetailApi}?lead_id=${leadId}`, getHeaders());
        return response;
    } catch (error) {
        return error.response;
    }
};

export const getB2BLeadAssignments = async (query = "") => {
    try {
        const qs = query ? (String(query).startsWith("?") ? query : `?${query}`) : "";
        const response = await axios.get(`${b2bLeadAssignmentsApi}${qs}`, getHeaders());
        return response;
    } catch (error) {
        return error.response;
    }
};

export const getB2BLeadInteractions = async (query = "") => {
    try {
        const qs = query ? (String(query).startsWith("?") ? query : `?${query}`) : "";
        const response = await axios.get(`${b2bLeadInteractionsApi}${qs}`, getHeaders());
        return response;
    } catch (error) {
        return error.response;
    }
};

export const getB2BLeadFollowups = async (query = "") => {
    try {
        const qs = query ? (String(query).startsWith("?") ? query : `?${query}`) : "";
        const response = await axios.get(`${b2bLeadFollowupsApi}${qs}`, getHeaders());
        return response;
    } catch (error) {
        return error.response;
    }
};

export const getB2BLeadNotes = async (leadId) => {
    try {
        const response = await axios.get(`${b2bLeadNotesCRUDApi}?lead=${leadId}`, getHeaders());
        return response;
    } catch (error) {
        return error.response;
    }
};

export const createB2BLeadNote = async (data) => {
    try {
        const response = await axios.post(b2bLeadNotesCRUDApi, data, getHeaders());
        return response;
    } catch (error) {
        return error.response;
    }
};

export const uploadB2BLeads = async (formData) => {
    try {
        const response = await axios.post(b2bLeadUploadApi, formData, {
            headers: {
                ...getHeaders().headers,
                "Content-Type": "multipart/form-data",
            },
            responseType: 'blob'
        });
        return response;
    } catch (error) {
        return error.response;
    }
};

export const getB2BCampaignFolders = async (query = "") => {
    try {
        const qs = query ? (String(query).startsWith("?") ? query : `?${query}`) : "";
        const response = await axios.get(`${b2bLeadsCampaignFolderApi}${qs}`, getHeaders());
        return response;
    } catch (error) {
        return error.response;
    }
};

export const getB2BDistrictFolders = async (query = "") => {
    try {
        const qs = query ? (String(query).startsWith("?") ? query : `?${query}`) : "";
        const response = await axios.get(`${b2bLeadsDistrictFolderApi}${qs}`, getHeaders());
        return response;
    } catch (error) {
        return error.response;
    }
};

export const downloadB2BLeads = async (query = "") => {
    try {
        const response = await axios.get(`${b2bClientDataDownloadApi}?${query}`, {
            ...getHeaders(),
            responseType: 'blob',
        });
        return response;
    } catch (error) {
        return error.response;
    }
};

export const getLeadStats = async (query = "") => {
    try {
        const response = await axios.get(`${leadStatsApi}${query}`, getHeaders());
        return response;
    } catch (error) {
        return error.response;
    }
};

export const getB2BSalespersonList = async () => {
    try {
        const response = await axios.get(b2bSalespersonListApi, getHeaders());
        return response;
    } catch (error) {
        return error.response;
    }
};

export const quickAddB2BLead = async (formData) => {
    try {
        const headers = getHeaders();
        const response = await axios.post(b2bQuickAddLeadApi, formData, {
            headers: {
                ...headers.headers,
                'Content-Type': 'multipart/form-data',
            }
        });
        return response;
    } catch (error) {
        return error.response;
    }
};

export const toggleB2BDealerStatus = async (assignmentId, isMyDealer) => {
    try {
        const response = await axios.patch(`${b2bLeadAssignmentsApi}${assignmentId}/`, {
            is_my_dealer: isMyDealer
        }, getHeaders());
        return response;
    } catch (error) {
        return error.response;
    }
};

export const getB2BMyDealers = async (query = "") => {
    try {
        const qs = query ? `?${query}` : "";
        const response = await axios.get(`${b2bMyDealersApi}${qs}`, getHeaders());
        return response;
    } catch (error) {
        return error.response;
    }
};

export const getPaidB2BDealers = async (query = "") => {
    try {
        const qs = query ? `?${query}` : "";
        const response = await axios.get(`${paidB2BDealersApi}${qs}`, getHeaders());
        return response;
    } catch (error) {
        return error.response;
    }
};
